export const DEV = "DEV";
export const SIT = "SIT";
export const PREPROD = "PREPROD";
export const PROD = "PROD";
export const DEVURL = 'http://sdea004:8080';
export const SITURL = 'http://ssta004:8080';
export const SIT2URL = 'http://ssta010:8080';
export const PPURL = 'http://sppa012:8080';
export const PRODURL = 'https://mobily.com.sa'